import * as Styled from './SupportDrawer.styled';
import SupportIcon from './assets/support.svg';
import { useCopilotWidget } from '@modules/copilot/hooks/useCopilotWidget';
import { StyledDrawer } from 'app/(authenticated)/_components/NavActions/components/StyledDrawer/StyledDrawer';
import { GetHelp } from 'app/(authenticated)/_components/NavActions/components/SupportDrawer/components/GetHelp/GetHelp';
import { useWorkspace } from 'app/_providers/WorkspaceProvider';

import { CloseOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { useState } from 'react';

export const SupportDrawer: React.FC = () => {
  const { leaderFQDN } = useWorkspace();
  const { data: isCopilotWidgetEnabled, isLoading: loadingCopilotWidget } = useCopilotWidget(leaderFQDN);
  const [isDrawerOpened, setIsDrawerOpened] = useState(false);

  const handleToggleDrawer = (): void => {
    setIsDrawerOpened((prev) => !prev);
  };

  if (!loadingCopilotWidget && isCopilotWidgetEnabled) {
    return null;
  }

  return (
    <Styled.SupportWrapper>
      <Tooltip title='Support'>
        <Styled.SupportIcon
          onClick={handleToggleDrawer}
          component={SupportIcon}
          aria-label='Support'
        />
      </Tooltip>

      <StyledDrawer
        title={
          <>
            Support
            <CloseOutlined
              onClick={handleToggleDrawer}
              size={12}
            />
          </>
        }
        onClose={handleToggleDrawer}
        open={isDrawerOpened}
        closeIcon={null}
        maskClosable
      >
        <Styled.Tabs
          items={[
            {
              key: 'help',
              label: 'Get Help',
              children: <GetHelp />,
            },
          ]}
        />
      </StyledDrawer>
    </Styled.SupportWrapper>
  );
};
